import React from 'react';
import Path from '@grebban/react-core-components/svg/Path';
import Svg from '@grebban/react-core-components/svg/Svg';
import { type CssColorKey } from 'config/branding/colors';
import { type CssVariable } from 'config/branding/types';

const sizes = {
    xsmall: {
        viewBox: '0 0 10 10',
        width: '10px',
        height: '10px',
        path: 'M3 1L7 5L3 9',
    },
    small: {
        viewBox: '0 0 16 16',
        width: '16px',
        height: '16px',
        path: 'M5 2L11 8L5 14',
    },
    large: {
        viewBox: '0 0 24 24',
        width: '24px',
        height: '24px',
        path: 'M8 3L16 12L8 21',
    },
};

export type ArrowRightIconSizes = keyof typeof sizes;

// @TODO Remove Record<string, unknown> when styled is fixed and we can correctly pass css via rest.
export interface ArrowRightIconProps extends Record<string, unknown> {
    color: CssVariable<CssColorKey>;
    height?: string | string[];
    size?: ArrowRightIconSizes;
    width?: string | string[];
    viewBox?: string | string[];
}

export const ArrowRightIcon = ({
    color = 'var(--color-base-black)',
    size = 'small',
    height,
    width,
    viewBox,
    ...rest
}: ArrowRightIconProps) => {
    const selectedSize = sizes[size];
    return (
        <Svg
            width={width || selectedSize.width}
            height={height || selectedSize.height}
            viewBox={viewBox || selectedSize.viewBox}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...rest}
        >
            <Path d={selectedSize.path} stroke={color} />
        </Svg>
    );
};
